// extracted by mini-css-extract-plugin
export var audioPlayer = "_qi-0";